var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComprehensiveSolutionH5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 81,
    viewBox: "0 0 160 81",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_3362)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    y: 0.783203,
    width: 160,
    height: 80,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8 36.7832V36.7832C110.37 36.7832 112.916 40.2471 111.849 43.6544L102.992 71.9509C101.807 75.7357 104.634 79.5832 108.6 79.5832V79.5832",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeDasharray: "2.4 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9553 42.7051C37.1672 39.163 40.4968 36.7832 44.2404 36.7832H106.8C102.875 36.7832 99.373 39.2471 98.0469 42.941L86.9461 73.8631C85.6282 77.5344 82.1473 79.9832 78.2465 79.9832H23.2001L35.9553 42.7051Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2001 46.7832H81.2001",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4004 53.9824H78.4004",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9904 72.2963C71.08 75.1702 72.1955 78.0812 74.3758 79.7169H18.6208C13.7053 79.7169 10.2697 74.8525 11.9134 70.22L14.8831 61.8503H75.2996L71.9904 72.2963Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.565 79.584H108.608C112.887 79.584 116.65 76.7515 117.834 72.639L127.861 37.7965C129.333 32.6827 125.495 27.584 120.173 27.584H72.193L69.2002 36.784",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 69.584H133.2C134.084 69.584 134.8 70.3003 134.8 71.184V78.384C134.8 79.2676 134.084 79.984 133.2 79.984H130",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.8 71.1836H136.489C137.483 71.1836 138.463 71.4149 139.351 71.8593L141.335 72.8512C141.509 72.9383 141.701 72.9836 141.896 72.9836H145.4C146.063 72.9836 146.6 73.5209 146.6 74.1836V74.1836C146.6 74.8463 146.063 75.3836 145.4 75.3836H140.839C140.686 75.3836 140.539 75.4443 140.431 75.5523L139.8 76.1836",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.6 77.7824H136.8L141.242 79.3094C142.485 79.7368 143.853 79.6034 144.991 78.9437L152.321 74.6921C152.829 74.3972 153.053 73.7802 152.852 73.2277V73.2277C152.609 72.5584 151.844 72.2416 151.199 72.5428L146.4 74.7824",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.2 59.1836V67.1836",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeDasharray: "2.67 0.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 60.7832V67.1832",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeDasharray: "2.67 0.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.2 67.1832V57.5832H153.6V57.3832L149.2 52.7832L144.8 57.3832V57.5832H147.2V58.1832",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.2 67.184V57.584",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeDasharray: "2.67 0.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4 67.1824V59.1824H144V58.9824L140.8 55.9824L137.6 58.9824V59.1824H139.2V59.5824",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.4 67.1828V60.7828H135.6V60.5828L133.2 58.3828L130.8 60.5828V60.7828H132V61.3828",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7998 13.584H146.337C151.42 13.584 155.214 18.2614 154.165 23.2344L149.2 46.784",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeDasharray: "2.4 1.6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.2,
    cy: 46.7828,
    r: 2.4,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5999 56.3828L13.5999 50.3828",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40015 61.1832L7.20015 52.7832",
    stroke: "black",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.8005,
    cy: 6.57818,
    rx: 12.583,
    ry: 5.64068,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.3668,
    cy: 10.0288,
    rx: 10.4136,
    ry: 3.47119,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.9531,
    y: 4.82227,
    width: 20.8271,
    height: 5.20678,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.9531,
    y: 4.82227,
    width: 20.8271,
    height: 5.20678,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.9531,
    y: 4.82227,
    width: 20.8271,
    height: 5.20678,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.9531,
    y: 4.82227,
    width: 20.8271,
    height: 5.20678,
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.3667,
    cy: 4.8208,
    rx: 10.4136,
    ry: 3.47119,
    fill: "#304FF2",
    stroke: "white",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-25-inside-1_437_3362",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9526 17.8613V23.0681H23.9527C23.9531 24.9851 28.6153 26.5391 34.3663 26.5391C40.1176 26.5391 44.7799 24.9849 44.7799 23.0679L44.7798 23.0518V17.8613C44.779 19.7782 40.117 21.332 34.3662 21.332C28.6154 21.332 23.9534 19.7782 23.9526 17.8613Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9526 17.8613V23.0681H23.9527C23.9531 24.9851 28.6153 26.5391 34.3663 26.5391C40.1176 26.5391 44.7799 24.9849 44.7799 23.0679L44.7798 23.0518V17.8613C44.779 19.7782 40.117 21.332 34.3662 21.332C28.6154 21.332 23.9534 19.7782 23.9526 17.8613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9526 17.8613L25.286 17.8608L22.6193 17.8613H23.9526ZM23.9526 23.0681H22.6193V24.4014H23.9526V23.0681ZM23.9527 23.0681L25.2861 23.0678L25.2858 21.7348H23.9527V23.0681ZM44.7799 23.0679H46.1132L46.1132 23.0588L44.7799 23.0679ZM44.7798 23.0518H43.4464L43.4465 23.0609L44.7798 23.0518ZM44.7798 17.8613H46.1131L43.4464 17.8608L44.7798 17.8613ZM22.6193 17.8613V23.0681H25.286V17.8613H22.6193ZM23.9526 24.4014H23.9527V21.7348H23.9526V24.4014ZM22.6194 23.0684C22.6196 24.1312 23.2671 24.9315 23.9461 25.4664C24.64 26.0133 25.5616 26.4474 26.5814 26.7874C28.6351 27.4719 31.3874 27.8724 34.3663 27.8724V25.2057C31.5942 25.2057 29.1399 24.8292 27.4247 24.2575C26.5601 23.9693 25.9565 23.6556 25.5965 23.3719C25.2215 23.0764 25.2861 22.9635 25.2861 23.0678L22.6194 23.0684ZM34.3663 27.8724C37.3454 27.8724 40.0977 27.4718 42.1514 26.7873C43.1713 26.4473 44.0929 26.0131 44.7868 25.4662C45.4657 24.9312 46.1132 24.1308 46.1132 23.0679H43.4465C43.4465 22.9635 43.5112 23.0763 43.1362 23.3718C42.7763 23.6555 42.1728 23.9693 41.3082 24.2575C39.5929 24.8292 37.1385 25.2057 34.3663 25.2057V27.8724ZM46.1132 23.0588L46.1131 23.0428L43.4465 23.0609L43.4466 23.0769L46.1132 23.0588ZM46.1131 23.0518V17.8613H43.4464V23.0518H46.1131ZM43.4464 17.8608C43.4465 17.7565 43.511 17.8694 43.1358 18.165C42.7758 18.4487 42.1722 18.7624 41.3076 19.0506C39.5924 19.6222 37.1381 19.9987 34.3662 19.9987V22.6654C37.345 22.6654 40.0971 22.2649 42.1508 21.5804C43.1707 21.2405 44.0922 20.8064 44.7862 20.2596C45.4651 19.7247 46.1126 18.9246 46.1131 17.8619L43.4464 17.8608ZM34.3662 19.9987C31.5942 19.9987 29.14 19.6222 27.4248 19.0506C26.5602 18.7624 25.9566 18.4487 25.5965 18.165C25.2214 17.8694 25.2859 17.7565 25.286 17.8608L22.6193 17.8619C22.6197 18.9246 23.2673 19.7247 23.9462 20.2596C24.6402 20.8064 25.5617 21.2405 26.5816 21.5804C28.6352 22.2649 31.3874 22.6654 34.3662 22.6654V19.9987Z",
    fill: "black",
    mask: "url(#path-25-inside-1_437_3362)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3663 14.9204C40.1176 14.9204 44.7799 13.3663 44.7799 11.4492V16.6552V16.6555C44.7793 18.5724 40.1172 20.1264 34.3663 20.1264C28.6154 20.1264 23.9533 18.5724 23.9528 16.6555V16.6552V11.4492C23.9528 13.3663 28.6151 14.9204 34.3663 14.9204Z",
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3663 14.9204C40.1176 14.9204 44.7799 13.3663 44.7799 11.4492V16.6552V16.6555C44.7793 18.5724 40.1172 20.1264 34.3663 20.1264C28.6154 20.1264 23.9533 18.5724 23.9528 16.6555V16.6552V11.4492C23.9528 13.3663 28.6151 14.9204 34.3663 14.9204Z",
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3663 14.9204C40.1176 14.9204 44.7799 13.3663 44.7799 11.4492V16.6552V16.6555C44.7793 18.5724 40.1172 20.1264 34.3663 20.1264C28.6154 20.1264 23.9533 18.5724 23.9528 16.6555V16.6552V11.4492C23.9528 13.3663 28.6151 14.9204 34.3663 14.9204Z",
    fill: "#304FF2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3663 14.9204C40.1176 14.9204 44.7799 13.3663 44.7799 11.4492V16.6552V16.6555C44.7793 18.5724 40.1172 20.1264 34.3663 20.1264C28.6154 20.1264 23.9533 18.5724 23.9528 16.6555V16.6552V11.4492C23.9528 13.3663 28.6151 14.9204 34.3663 14.9204Z",
    fill: "#304FF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_3362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 80,
    fill: "white",
    transform: "translate(0 0.783203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComprehensiveSolutionH5);
export default __webpack_public_path__ + "static/media/comprehensive_solution_h5.f6dba3315ff28e2cbc413bd2448c581e.svg";
export { ForwardRef as ReactComponent };